export default __webpack_public_path__ + "static/media/wear-masks.083de502.svg";